"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUnsortedStateAdapter = createUnsortedStateAdapter;

var _ramda = require("ramda");

var _utils = require("./utils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function createUnsortedStateAdapter(getId) {
  var safeGetId = function safeGetId(entity) {
    var id;

    try {
      id = getId(entity);
    } catch (_unused) {
      id = undefined;
    }

    return id;
  };

  var addOneImmutable = function addOneImmutable(entity, state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ids: [].concat(_toConsumableArray(state.ids), [getId(entity)]),
      entities: _objectSpread(_objectSpread({}, state.entities), {}, _defineProperty({}, getId(entity), entity))
    });
  };

  var addManyImmutable = function addManyImmutable(entities, state) {
    var list = (0, _utils.ensureEntitiesArray)(entities);
    return list.reduce(function (acc, item) {
      return addOneImmutable(item, acc);
    }, state);
  };

  var updateOneImmutable = function updateOneImmutable(update, state) {
    if (!(update.id in state.entities)) {
      return state;
    }

    var id = safeGetId(update.changes) || update.id;
    var isIdChanged = id !== update.id;
    var ids = state.ids;

    if (isIdChanged) {
      ids = ids.map(function (curId) {
        return curId === update.id ? id : curId;
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      ids: ids,
      entities: _objectSpread(_objectSpread({}, state.entities), {}, _defineProperty({}, id, _objectSpread(_objectSpread({}, state.entities[id]), update.changes)))
    });
  };

  var updateManyImmutable = function updateManyImmutable(updates, state) {
    return updates.reduce(function (nextState, update) {
      return updateOneImmutable(update, nextState);
    }, state);
  };

  var upsertManyImmutable = function upsertManyImmutable(newEntities, state) {
    var _splitAddedUpdatedEnt = (0, _utils.splitAddedUpdatedEntities)(newEntities, getId, state),
        _splitAddedUpdatedEnt2 = _slicedToArray(_splitAddedUpdatedEnt, 2),
        added = _splitAddedUpdatedEnt2[0],
        updated = _splitAddedUpdatedEnt2[1];

    return addManyImmutable(added, updateManyImmutable(updated, state));
  };

  var upsertOneImmutable = function upsertOneImmutable(newEntity, state) {
    return upsertManyImmutable([newEntity], state);
  };

  var setOneImmutable = function setOneImmutable(entity, state) {
    var id = getId(entity);
    var ids = state.ids;

    if (!(id in state.entities)) {
      ids = [].concat(_toConsumableArray(ids), [id]);
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      ids: ids,
      entities: _objectSpread(_objectSpread({}, state.entities), {}, _defineProperty({}, id, entity))
    });
  };

  var setManyImmutable = function setManyImmutable(entities, state) {
    var list = (0, _utils.ensureEntitiesArray)(entities);
    return list.reduce(function (nextState, entity) {
      return setOneImmutable(entity, state);
    }, state);
  };

  var setAllImmutable = function setAllImmutable(entities, state) {
    var newEntities = (0, _utils.ensureEntitiesArray)(entities);
    var ids = newEntities.map(getId);
    var nextEntities = (0, _ramda.indexBy)(getId, newEntities);
    return _objectSpread(_objectSpread({}, state), {}, {
      ids: ids,
      entities: nextEntities
    });
  };

  var removeOneImmutable = function removeOneImmutable(key, state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ids: (0, _ramda.filter)(function (entityId) {
        return entityId !== key;
      }, state.ids),
      entities: (0, _ramda.omit)([key], state.entities)
    });
  };

  var removeAllImmutable = function removeAllImmutable(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      ids: [],
      entities: {}
    });
  };

  return {
    addOne: addOneImmutable,
    addMany: addManyImmutable,
    updateOne: updateOneImmutable,
    updateMany: updateManyImmutable,
    upsertOne: upsertOneImmutable,
    upsertMany: upsertManyImmutable,
    setOne: setOneImmutable,
    setMany: setManyImmutable,
    setAll: setAllImmutable,
    removeOne: removeOneImmutable,
    removeAll: removeAllImmutable
  };
}